import ConfidentialityNotice from './ConfidentialityNotice';

export { ConfidentialityNotice };
